/**
 * Composant ConfigDialog - Dialogue de configuration des taux horaires
 */

import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../ui/dialog';

export const ConfigDialog = ({
  open,
  onOpenChange,
  config,
  setConfig,
  onSave
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="config-dialog">
        <DialogHeader>
          <DialogTitle>Configuration des taux</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          <div>
            <Label htmlFor="taux_1">Taux 1 (Auto-financé) - €/h</Label>
            <Input
              id="taux_1"
              type="number"
              step="0.01"
              value={config.taux?.taux_1 || 11}
              onChange={(e) => setConfig({...config, taux: {...config.taux, taux_1: parseFloat(e.target.value)}})}
              data-testid="input-taux-1"
            />
          </div>
          <div>
            <Label htmlFor="taux_2">Taux 2 (CFA) - €/h</Label>
            <Input
              id="taux_2"
              type="number"
              step="0.01"
              value={config.taux?.taux_2 || 12}
              onChange={(e) => setConfig({...config, taux: {...config.taux, taux_2: parseFloat(e.target.value)}})}
              data-testid="input-taux-2"
            />
          </div>
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Annuler
          </Button>
          <Button 
            onClick={onSave}
            className="bg-[#8DC63F] hover:bg-[#7AB62F]"
            data-testid="save-taux-btn"
          >
            Enregistrer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfigDialog;
